import ProgramExplorer from './ProgramExplorer';

const PROGRAMS = [
  {
    icon: 'role-play',
    title: 'Professional Communication & Workplace Etiquette',
    desc: 'Everyday professional communication and etiquette that help students present themselves with polish and confidence.',
    tags: ['Business etiquette', 'First impressions', 'Professionalism'],
  },
  {
    icon: 'workshop',
    title: 'Public Speaking, Presentation & Confidence Building',
    desc: 'Structured practice in public speaking and presentation that turns hesitant students into confident communicators.',
    tags: ['Stage confidence', 'Storytelling', 'Body language'],
  },
  {
    icon: 'bar-growth',
    title: 'Campus to Corporate Readiness & Growth Mindset',
    desc: 'Bridge the gap between academics and the workplace with real corporate expectations and a growth mindset.',
    tags: ['Work readiness', 'Growth mindset', 'Adaptability'],
  },
  {
    icon: 'group',
    title: 'Leadership, Teamwork & Emotional Intelligence',
    desc: 'Build collaborative, emotionally intelligent students who can lead teams and work well with others.',
    tags: ['Collaboration', 'EQ', 'Team leadership'],
  },
  {
    icon: 'award-ribbon',
    title: 'Safe, Inclusive & Responsible Workplace Awareness',
    desc: 'Awareness of safe, inclusive and responsible conduct that prepares students for modern, respectful workplaces.',
    tags: ['Inclusion', 'Responsibility', 'Awareness'],
  },
];

export default function ForColleges() {
  return (
    <ProgramExplorer
      id="for-colleges"
      variant="light"
      eyebrow="CAMPUS TO CORPORATE EXCELLENCE PROGRAM"
      title="For Colleges & Universities"
      intro="We partner with educational institutions to bridge the gap between academic learning and corporate expectations, building confident communicators, responsible professionals and future leaders ready for the modern workplace."
      programs={PROGRAMS}
      ctaText="Enquire for campus programs"
      ctaClass="btn-dark"
    />
  );
}
